import { ReactElement } from "react";
import { Order } from "../types";
import { classNames } from "primereact/utils";

type PropTypes = {
    documents: Order[]
};
function AvailabeDocuments(props: PropTypes): ReactElement {

    const {
        documents
    } = props;

    return (
        <div className="w-full flex flex-column row-gap-4">           
            <div className="text-color text-base font-normal text-center">
                You will receive all available physical copies in this shipment.
            </div>
            {
                documents.map(document => {

                    return (
                        <div key={document.orderNumber} className="flex flex-column gap-3 p-3 p-card p-component">
                            <div className="font-bold text-lg text-900">
                                <span className="mr-1">Order</span>
                                <span>#{document.orderNumber}</span>
                            </div>
                            {
                                document.documentsAvailable.length ? (
                                    <div className="flex-grow-1">
                                        <div className="font-semibold text-lg text-color">
                                           Available Physical Copies:
                                        </div>

                                        <ul className="list-none mt-3">
                                            {
                                                document.documentsAvailable.map((doc, idx) => {
                                                    return (
                                                        <li key={document.orderNumber.concat(`-${doc.status}`)} >
                                                            <div>
                                                                <span className="mr-2 text-color">
                                                                    <i className={classNames("text-base pi", {
                                                                        "pi-file-word": doc.status === "ACKNOWLEDGED_COPY",
                                                                        "pi-envelope": doc.status === "MAILED_COPY",
                                                                        "pi-file": doc.status === "RETURN_RECEIPT",
                                                                    })} />
                                                                </span>
                                                                <span className="font-normal text-lg text-color">
                                                                    {doc.fileName}
                                                                </span>
                                                            </div>
                                                        </li>
                                                    )
                                                })
                                            }
                                        </ul>
                                    </div>
                                ) : null
                            }
                        </div>
                    )
                })
            }

        </div>
    )
}

export default AvailabeDocuments